<template>
  <p
    class="mt-3 mb-3 d-inline-block baseColor"
    @click="toggleLanguage">{{ $t("LANGUAGE_PICKER.TEXT") }}</p>
</template>

<script>
import moment from 'moment';

export default {
  name: 'LanguagePicker',
  components: {},
  methods: {
    toggleLanguage() {
      if (this.$i18n.locale === 'fr') {
        moment.locale('en_CA');
        this.$i18n.locale = 'en';
      } else {
        moment.locale('fr_CA');
        this.$i18n.locale = 'fr';
      }
    },
  },
};
</script>

<style scoped lang="scss">
p {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
